import { useLocation } from 'react-router-dom'
import {
  FARM_SELECTOR_FARM_AND_CLIENTS_ALLOWED_PAGES,
  FARM_SELECTOR_FARM_AND_CLIENTS_EXCLUDED_PATHS,
  FARM_SELECTOR_ONLY_FARM_ALLOWED_PAGES,
  FARM_SELECTOR_SETTINGS_EXCLUDED_PATH,
} from '../constants'
import { isFlowTheme } from 'src/Libs/utils'

interface UseFarmSelectorLocationHook {
  farmAndClientsSelectorIsAllowed: boolean
  farmSelectorIsAllowed: boolean
}

/**
 * Hook used to get information whether the [Farm Selector Component](src/Elements/Framework/Header/FarmSelector) can be implemented on the current page.
 * The information is given in form of farmAndClientsSelectorIsAllowed and farmSelectorIsAllowed parameters to know if only farm or also clients can be selected.
 */
const useFarmSelectorLocation = (): UseFarmSelectorLocationHook => {
  const location = useLocation()

  const farmSelectorIsAllowed = FARM_SELECTOR_ONLY_FARM_ALLOWED_PAGES.some(page => location.pathname.includes(page))
  const isFlowSettingsPage = isFlowTheme && location.pathname.includes(FARM_SELECTOR_SETTINGS_EXCLUDED_PATH) && !farmSelectorIsAllowed

  const isFarmAndClientsExcludedPath = FARM_SELECTOR_FARM_AND_CLIENTS_EXCLUDED_PATHS.some(path => location.pathname.includes(path))

  const farmAndClientsSelectorIsAllowed =
    !isFarmAndClientsExcludedPath &&
    !isFlowSettingsPage &&
    FARM_SELECTOR_FARM_AND_CLIENTS_ALLOWED_PAGES.some(page => location.pathname.startsWith(page))

  return { farmAndClientsSelectorIsAllowed, farmSelectorIsAllowed }
}

export default useFarmSelectorLocation
